import { CButton, CCard, CCardBody, CCol, CForm, CInputGroup, CRow } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import BaseListing from 'src/BaseListings'
import WidgetBranchSelector from '../../widgets/Selectors/WidgetBranchSelector'
import WidgetDepartmentSelector from '../../widgets/Selectors/WidgetDepartmentSelector'
import WidgetDesignationSelector from '../../widgets/Selectors/WidgetDesignationSelector'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import WidgetEmployeeSelector from 'src/widgets/Selectors/WidgetEmployeeSelector'
import DetailedDataReportTable from './DetailedDataReportTable'
import Loading from 'src/helpers/commons/loader'
import ErrorMessage from 'src/widgets/ErrorComponent/ErrorMessage'
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage'
import { fileStatusOptions, JobTypeOptions, SortByIdOrDesignation, YesNoOptions } from 'src/helpers/commons/dropdownOptions'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import WidgetBranchMultiSelector from 'src/widgets/Multi-Selectors/WidgetBranchMultiSelector'
import { useMasterDateTimeFormats } from 'src/helpers/commons/masterDateFormat'

const defaultCheckedList = [
  'id',
  'personal_file_no',
  'full_name',
  'designation_id',
  'department_id',
]

export default function EmployeeDataReport() {
  const Base = new BaseListing()
  const defaultBranchId = +wtGetFromLocalStorage('default_branch_id', 0) || 0
  const defaultBranchName = wtGetFromLocalStorage('default_branch_name', '') || ''
  const { formatDate } = useMasterDateTimeFormats()
  const [isLoading, setIsLoading] = useState(false)
  const [Employees, setEmployees] = useState([])
  const [EmployeeId, setEmployeeId] = useState(0)
  const [EmployeeName, setEmployeeName] = useState('')
  const [branches, setBranches] = useState([])
  const [branchId, setBranchId] = useState(defaultBranchId)
  const [branch_name, setBranchName] = useState(defaultBranchName)
  const [departments, setDepartments] = useState([])
  const [department_id, setDepartmentId] = useState(0)
  const [department_name, setDepartmentName] = useState('')
  const [designations, setDesignations] = useState([])
  const [designation_id, setDesignationId] = useState(0)
  const [designation_name, setDesignationName] = useState('')
  const [errors, setErrors] = useState([])
  const [isMore, setIsMore] = useState(false)
  const [reportData, setReportData] = useState([])
  const [JobType, setJobType] = useState('')
  const [ResignationStatus, setResignationStatus] = useState(0)
  const [selectedBranches, setSelectedBranches] = useState([])
  const [isOfficer, setIsOfficer] = useState(null)
  const [SortBy, setSortBy] = useState()

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 100,
      key: 'id',
      fixed: 'left',
    },
    {
      title: 'File No',
      dataIndex: 'personal_file_no',
      width: 100,
      key: 'personal_file_no',
      fixed: 'left',
    },
    {
      title: 'Full Name',
      dataIndex: 'full_name',
      width: 250,
      key: 'full_name',
      fixed: 'left',
    },
    {
      title: 'Designation',
      key: 'designation_id',
      render: (record) => record.designation.name,
    },
    {
      title: 'Department',
      key: 'department_id',
      render: (record) => record.department.name,
    },
    {
      title: 'Moblie NO',
      dataIndex: 'mobile_no',
      key: 'moblie_no',
    },
    {
      title: 'Phone No',
      dataIndex: 'phone_no',
      key: 'phone_no',
    },
    {
      title: 'Permanent Address',
      dataIndex: 'permanent_address',
      key: 'permanent_address',
    },
    {
      title: 'Resident Address',
      dataIndex: 'resident_address',
      key: 'resident_address',
    },
    {
      title: 'Gender',
      dataIndex: 'gender',
      key: 'gender',
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      key: 'grade',
    },
    {
      title: 'Domicile',
      dataIndex: 'domicile',
      key: 'domicile',
    },
    {
      title: 'CNIC',
      dataIndex: 'cnic',
      key: 'cnic',
    },
    {
      title: 'CNIC Issue Date',
      dataIndex: 'cnic_issue_date',
      key: 'cnic_issue_date',
      render: (text) => formatDate(text),
      isDate: true,
    },
    {
      title: 'CNIC Expiry Date',
      dataIndex: 'cnic_expiry_date',
      key: 'cnic_expiry_date',
      render: (text) => formatDate(text),
      isDate: true,
    },
    {
      title: 'Date Of Birth',
      dataIndex: 'date_of_birth',
      key: 'date_of_birth',
      render: (text) => formatDate(text),
      isDate: true,
    },
    {
      title: 'Date Of Join',
      dataIndex: 'date_of_joining',
      key: 'date_of_joining',
      render: (text) => formatDate(text),
      isDate: true,
    },
    {
      title: 'Duration',
      dataIndex: 'duration',
      key: 'duration',
    },
    {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
    },
    {
      title: 'Job Status',
      dataIndex: 'job_status',
      key: 'job_status',
    },
    {
      title: 'Personal Email',
      dataIndex: 'personal_email',
      key: 'personal_email',
    },
    {
      title: 'Official Email',
      dataIndex: 'official_email',
      key: 'official_email',
    },
    {
      title: 'Marital Status',
      dataIndex: 'marital_status',
      key: 'marital_status',
    },
    {
      title: 'Blood Group',
      dataIndex: 'blood_group',
      key: 'blood_group',
    },
    {
      title: 'Driving License Issue Date',
      dataIndex: 'driving_license_issue_date',
      key: 'driving_license_issue_date',
      render: (text) => formatDate(text),
      isDate: true,
    },
    {
      title: 'Driving License Expiry Date',
      dataIndex: 'driving_license_expiry_date',
      key: 'driving_license_expiry_date',
      render: (text) => formatDate(text),
      isDate: true,
    },
    {
      title: 'Expiry Date',
      dataIndex: 'expiry_date',
      key: 'expiry_date',
      render: (text) => formatDate(text),
      isDate: true,
    },
    {
      title: 'Emergency Contact Name',
      dataIndex: 'emergency_contact_name',
      key: 'emergency_contact_name',
    },
    {
      title: 'Relationship With Employee',
      dataIndex: 'relationship_with_employee',
      key: 'relationship_with_employee',
    },
    {
      title: 'Emergency phone No',
      dataIndex: 'emergency_phone_no',
      key: 'emergency_phone_no',
    },
    {
      title: 'Emergency Resident Address',
      dataIndex: 'emergency_resident_address',
      key: 'emergency_resident_address',
    },
    {
      title: 'Emergency Email',
      dataIndex: 'emergency_email',
      key: 'emergency_email',
    },
    {
      title: 'Form Status',
      dataIndex: 'file_status',
      key: 'file_status',
      render: (text, record) => fileStatusOptions[record.file_status],
    },
    {
      title: 'Evaluation Template',
      dataIndex: 'performance_evaluation_template',
      key: 'performance_evaluation_template',
    },
    {
      title: 'Reporting To Name',
      key: 'reporting_to_id',
      render: (record) => (record.reporting_to ? record.reporting_to.full_name : '-'),
    },
    {
      title: 'Manual Attendance',
      key: 'manual_attendance',
      render: (record) => (record.manual_attendance == 1 ? 'Yes' : 'No'),
    },
    {
      title: 'Exampted From Attendance',
      key: 'exempt_from_attendance',
      render: (record) => (record.exempt_from_attendance == 1 ? 'Yes' : 'No'),
    },
    {
      title: 'Attendance Change Limit',
      key: 'attendance_change_monthly_limit',
      render: (record) => record.attendance_change_monthly_limit,
    },
    {
      title: 'PL Number',
      key: 'pl_number',
      render: (record) => record.pl_number,
    },
  ]

  const RESIGNATION_STATUS_ACTIVE = 0;
  const RESIGNATION_STATUS_RESIGNED = 1;
  const RESIGNATION_STATUS_TERMINATE = 2;
  const RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT = 3;
  const RESIGNATION_STATUS_RETIREMENT = 4;
  const RESIGNATION_STATUS_IN_SERVICE_DEATH = 5;

  const RESIGNATION_STATUS_NAME = {
    0: 'Active',
    1: 'Resigned',
    2: 'Terminated',
    3: 'Contract Discontinued',
    4: 'Retired',
    5: 'Passed Away',
  };

  const RESIGNATION_STATUS_DROPDOWN_OPTIONS = [
    { value: RESIGNATION_STATUS_ACTIVE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_ACTIVE] },
    { value: RESIGNATION_STATUS_RESIGNED, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RESIGNED] },
    { value: RESIGNATION_STATUS_TERMINATE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_TERMINATE] },
    { value: RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT] },
    { value: RESIGNATION_STATUS_RETIREMENT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RETIREMENT] },
    { value: RESIGNATION_STATUS_IN_SERVICE_DEATH, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_IN_SERVICE_DEATH] },
  ];


  const changeValues = (key, val) => {
    if (key === 'branch_id') {
      setBranchId(val.value)
      setBranchName(val.label)
    }
    if (key === 'department_id') {
      setDepartmentId(val.value)
      setDepartmentName(val.label)
    }
    if (key === 'designation_id') {
      setDesignationId(val.value)
      setDesignationName(val.label)
    }
    if (key === 'employee_id') {
      setEmployeeId(val.value)
      setEmployeeName(val.label)
    }
    if (key === 'resignation_status') {
      setResignationStatus(val.value)
    }
  }

  const getReportData = () => {
    setIsLoading(true)
    const branchIds = selectedBranches.map(({ value }) => value)

    wtApiCall(
      'reports/employee_detailed_data_report',
      {
        employee_id: EmployeeId,
        parent_branch_id: branchId,
        department_id: department_id,
        designation_id: designation_id,
        job_status: JobType,
        is_officer: isOfficer,
        resignation_status: ResignationStatus,
        // Send only branch IDs; the API applies these together with the
        // active header branch and parent-branch filters.
        branch_ids: branchIds,
        sort_by_id_or_designation: SortBy || 0,
      },
      'get',
      (response) => {
        const { data } = response
        setReportData(data)
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
      },
    )
  }

  useEffect(() => {
    Base.dropdownData(
      'employees,branches,designations,departments',
      {},
      [setEmployees, setBranches, setDesignations, setDepartments],
      1,
    )
    setBranchId(defaultBranchId)
    setBranchName(defaultBranchName)
  }, [])
  return (
    <>
      <div style={{ padding: '2%' }}>
        <center>
          <h4>Employee Detailed Data Report</h4>
        </center>
        <CRow style={{ width: '100%' }}>
          <CCol md={12}>
            <CCard className="card-dark">
              <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
                <br />
                <CForm>
                  <CRow>
                    {/* <CCol md={1}></CCol> */}
                    <CCol md={1}>
                      <CInputGroup>
                        <label style={{ fontSize: '140%', marginTop: '50px' }}>Filters:</label>
                      </CInputGroup>
                    </CCol>
                    <CCol md={2}>
                      <CInputGroup>
                        <label>Employee</label>
                        <WidgetEmployeeSelector
                          employees={Employees}
                          displayValue={EmployeeName}
                          value={EmployeeId}
                          placeholder="Select Employee"
                          onChange={(values) => changeValues('employee_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('employees', {}, [setEmployees], 1)
                          }
                        />
                        {errors.employee_id && <ErrorMessage messages={errors.employee_id} />}
                      </CInputGroup>
                    </CCol>

                    <CCol md={2}>
                      <CInputGroup>
                        <label>Department</label>
                        <WidgetDepartmentSelector
                          departments={departments}
                          displayValue={department_name}
                          value={department_id}
                          placeholder="Select Department"
                          onChange={(values) => changeValues('department_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('departments', {}, [setDepartments], 1)
                          }
                        />
                        {errors.department_id && <ErrorMessage messages={errors.department_id} />}
                      </CInputGroup>
                    </CCol>
                    <CCol md={2}>
                      <CInputGroup>
                        <label>Designation</label>
                        <WidgetDesignationSelector
                          designations={designations}
                          displayValue={designation_name}
                          value={designation_id}
                          placeholder="Select Designation"
                          onChange={(values) => changeValues('designation_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('designations', {}, [setDesignations], 1)
                          }
                        />
                        {errors.designation_id && <ErrorMessage messages={errors.designation_id} />}
                      </CInputGroup>
                    </CCol>
                    <CCol md={2}>
                      <CInputGroup>
                        <label>Job Type:</label>
                        <WidgetSelector
                          options={JobTypeOptions}
                          placeHolder={'Please Select'}
                          selectedValue={JobType}
                          onChange={(values) => setJobType(values.value)}
                        />
                        {errors.job_status && <ErrorMessage messages={errors.job_status} />}
                      </CInputGroup>
                    </CCol>
                    <CCol md={2}>
                      <CButton
                        color="primary"
                        onClick={() => getReportData()}
                        style={{ marginLeft: '1%', marginTop: '8%' }}
                      >
                        Search
                      </CButton>
                      <CButton
                        color="warning"
                        className="text-white"
                        onClick={() => setIsMore(!isMore)}
                        style={{ marginTop: '8%' }}
                      >
                        More
                      </CButton>
                    </CCol>
                  </CRow>
                  {isMore && (
                    <>
                      <CRow>
                        <CCol md={1}></CCol>
                        <CCol md={2}>
                          <CInputGroup>
                            <label>Resignation Status</label>
                            <WidgetSelector
                              options={RESIGNATION_STATUS_DROPDOWN_OPTIONS}
                              placeHolder={'Please Select'}
                              selectedValue={ResignationStatus}
                              onChange={(values) => changeValues('resignation_status', values)}

                            />
                            {errors.resignation_status && <ErrorMessage messages={errors.resignation_status} />}
                          </CInputGroup>
                        </CCol>
                        <CCol md={2}>
                          <CInputGroup>
                            <label>Parent Branch</label>
                            <WidgetBranchSelector
                              branches={branches}
                              displayValue={branch_name}
                              value={branchId}
                              placeholder="Select Branch"
                              onChange={(values) => changeValues('branch_id', values)}
                              reloadDropdownData={() =>
                                Base.dropdownData('branches', {}, [setBranches], 1)
                              }
                            />
                            {errors.department_id && <ErrorMessage messages={errors.department_id} />}
                          </CInputGroup>
                        </CCol>
                        <CCol md={2}>
                          <CInputGroup>
                            <label>Branch</label>
                            <WidgetBranchMultiSelector
                              Branches={branches}
                              value={selectedBranches}
                              onChange={(selectedOptions) => setSelectedBranches(selectedOptions)}
                            />
                            {errors.department_id && <ErrorMessage messages={errors.department_id} />}
                          </CInputGroup>
                        </CCol>
                        <CCol md={2}>
                          <CInputGroup>
                            <label>Is Officer?</label>
                            <WidgetSelector
                              options={[{ value: '*', label: 'All' }, ...YesNoOptions]}
                              onChange={(values) => setIsOfficer(values.value)}
                              selectedValue={isOfficer}
                            />
                            {errors.branch_id && <ErrorMessage messages={errors.branch_id} />}
                          </CInputGroup>
                        </CCol>
                        <CCol md={2}>
                          <CInputGroup>
                            <label>Sort By</label>
                            <WidgetSelector
                              options={SortByIdOrDesignation}
                              onChange={(values) => setSortBy(values.value)}
                              selectedValue={SortBy}
                            />
                            {errors.branch_id && <ErrorMessage messages={errors.branch_id} />}
                          </CInputGroup>
                        </CCol>
                      </CRow>
                      {/* <CRow>
                        <CCol md={1}></CCol>
                       
                      </CRow> */}
                    </>
                  )}
                  <br />
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <br />
        <br />
        {isLoading ? (
          Loading
        ) : (
          <>
            {reportData.length > 0 ? (
              <DetailedDataReportTable
                reportData={reportData}
                isLoading={isLoading}
                columns={columns}
                defaultCheckedList={defaultCheckedList}
              />
            ) : (
              <center style={{ fontSize: '19px', fontWeight: 'bold' }}>No record to show...</center>
            )}
          </>
        )}
      </div >
    </>
  )
}
